import { ProductName } from "module/interfaces/formInterface";
import {
  ICheckSubscriptionAccountByIdAction,
  ICheckSubscriptionAccountByIdActionPayload,
  ICreateSession,
  ICreateSubscriptionAccountByIdAction,
  IFetchAccountDetailsAction,
  IFetchIntent,
  IFetchInvoiceData,
  IGeoLocationResponse,
  IGetInvoice,
  IInvoiceSuccessAction,
  ISubscriptionAccount,
  ISubscriptionAccountData,
  ISubscriptionAccountWithCallback,
  ISubscriptionPlans,
  IUpdatePaymentMethod,
  IUpdatePaymentStatusPayload,
  IUpdateSubscriptionAccountByIdAction,
  Icallback,
  IcreateSubcription,
  InvoiceData,
} from "./interface";
import { IUserSubscription, IUserSubscriptionsResponse } from "../common/interface";

const actionTypePrefix = "SUBSCRIPTION/";

export const subscriptionActions = {
  FETCH_CATALOGUE: `${actionTypePrefix}FETCH_CATALOGUE`,
  FETCH_CATALOGUE_SUCCESS: `${actionTypePrefix}FETCH_CATALOGUE_SUCCESS`,
  FETCH_CATALOGUE_FAILURE: `${actionTypePrefix}FETCH_CATALOGUE_FAILURE`,

  FETCH_INVOICE: `${actionTypePrefix}FETCH_INVOICE`,
  FETCH_INVOICE_SUCCESS: `${actionTypePrefix}FETCH_INVOICE_SUCCESS`,
  FETCH_INVOICE_FAILURE: `${actionTypePrefix}FETCH_INVOICE_FAILURE`,

  FETCH_INVOICE_PAYMENTS: `${actionTypePrefix}FETCH_INVOICE_PAYMENTS`,
  FETCH_INVOICE_PAYMENTS_SUCCESS: `${actionTypePrefix}FETCH_INVOICE_PAYMENTS_SUCCESS`,
  FETCH_INVOICE_PAYMENTS_FAILURE: `${actionTypePrefix}FETCH_INVOICE_PAYMENTS_FAILURE`,

  UPDATE_INVOICE_LIST: `${actionTypePrefix}UPDATE_INVOICE_LIST`,

  CHECK_SUBSCRIPTION_ACCOUNT_BY_ID: `${actionTypePrefix}CHECK_SUBSCRIPTION_ACCOUNT_BY_ID`,
  CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_SUCCESS: `${actionTypePrefix}CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_SUCCESS`,
  CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_FAILURE: `${actionTypePrefix}CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_FAILURE`,

  CREATE_SUBSCRIPTION_ACCOUNT: `${actionTypePrefix}CREATE_SUBSCRIPTION_ACCOUNT`,
  CREATE_SUBSCRIPTION_ACCOUNT_SUCCESS: `${actionTypePrefix}CREATE_SUBSCRIPTION_ACCOUNT_SUCCESS`,
  CREATE_SUBSCRIPTION_ACCOUNT_FAILURE: `${actionTypePrefix}CREATE_SUBSCRIPTION_ACCOUNT_FAILURE`,

  CREATE_SUBSCRIPTION: `${actionTypePrefix}CREATE_SUBSCRIPTION`,
  CREATE_PAYMENT_SESSION: `${actionTypePrefix}CREATE_PAYMENT_SESSION`,
  UPDATE_PAYMENT_METHOD: `${actionTypePrefix}UPDATE_PAYMENT_METHOD`,

  UPDATE_SUBSCRIPTION_ACCOUNT: `${actionTypePrefix}UPDATE_SUBSCRIPTION_ACCOUNT`,
  UPDATE_SUBSCRIPTION_ACCOUNT_SUCCESS: `${actionTypePrefix}UPDATE_SUBSCRIPTION_ACCOUNT_SUCCESS`,
  UPDATE_SUBSCRIPTION_ACCOUNT_FAILURE: `${actionTypePrefix}UPDATE_SUBSCRIPTION_ACCOUNT_FAILURE`,

  FETCH_PAYMENT_INTENT: `${actionTypePrefix}FETCH_PAYMENT_INTENT`,
  UPDATE_PAYMENT_STATUS: `${actionTypePrefix}UPDATE_PAYMENT_STATUS`,

  FETCH_USER_LOCATION: `${actionTypePrefix}FETCH_USER_LOCATION`,
  FETCH_USER_LOCATION_SUCCESS: `${actionTypePrefix}FETCH_USER_LOCATION_SUCCESS`,
  FETCH_USER_LOCATION_FAILURE: `${actionTypePrefix}FETCH_USER_LOCATION_FAILURE`,

  FETCH_ACCOUNT_DETAILS: `${actionTypePrefix}FETCH_ACCOUNT_DETAILS`,
  FETCH_ACCOUNT_DETAILS_SUCCESS: `${actionTypePrefix}FETCH_ACCOUNT_DETAILS_SUCCESS`,
  FETCH_ACCOUNT_DETAILS_FAILURE: `${actionTypePrefix}FETCH_ACCOUNT_DETAILS_FAILURE`,

  SET_ACTIVE_PRODUCT_NAME: `${actionTypePrefix}SET_ACTIVE_PRODUCT_NAME`,

  SET_ACTIVE_FORM_MODE: `${actionTypePrefix}SET_ACTIVE_FORM_MODE`,

  FETCH_USER_SUBSCRIPTIONS: 'FETCH_USER_SUBSCRIPTIONS',
  FETCH_USER_SUBSCRIPTIONS_SUCCESS: 'FETCH_USER_SUBSCRIPTIONS_SUCCESS',
  FETCH_USER_SUBSCRIPTIONS_FAILURE: 'FETCH_USER_SUBSCRIPTIONS_FAILURE',

  FETCH_USER_SUBSCRIPTION_STATUS: 'FETCH_USER_SUBSCRIPTION_STATUS',
  FETCH_USER_SUBSCRIPTIONS_STATUS_SUCCESS: 'FETCH_USER_SUBSCRIPTIONS_STATUS_SUCCESS',
  FETCH_USER_SUBSCRIPTIONS_STATUS_FAILURE: 'FETCH_USER_SUBSCRIPTIONS_STATUS_FAILURE',

  FETCH_SUBSCRIPTIONS_INVOICES: 'FETCH_SUBSCRIPTIONS_INVOICES',
  FETCH_SUBSCRIPTIONS_INVOICES_SUCCESS: 'FETCH_SUBSCRIPTIONS_INVOICES_SUCCESS',
  FETCH_SUBSCRIPTIONS_INVOICES_FAILURE: 'FETCH_SUBSCRIPTIONS_INVOICES_FAILURE',

  FETCH_PAYMENT_STATUS: 'FETCH_PAYMENT_STATUS',
  FETCH_PAYMENT_STATUS_SUCCESS: 'FETCH_PAYMENT_STATUS_SUCCESS',
  FETCH_PAYMENT_STATUS_FAILURE: 'FETCH_PAYMENT_STATUS_FAILURE',
};

export const fetchCatalogueAction = (productName: string) => {
  return {
    type: subscriptionActions.FETCH_CATALOGUE,
    payload: {
      productName: productName,
    },
  };
};

export const fetchCatalogueSuccessAction = (payload: ISubscriptionPlans) => {
  return {
    type: subscriptionActions.FETCH_CATALOGUE_SUCCESS,
    payload,
  };
};

export const fetchCatalogueFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.FETCH_CATALOGUE_FAILURE,
    payload,
  };
};

export const fetchInvoiceAction = (payload: IGetInvoice) => {
  return {
    type: subscriptionActions.FETCH_INVOICE,
    payload,
  };
};

export const fetchInvoiceSuccessAction = (payload: IInvoiceSuccessAction) => {
  return {
    type: subscriptionActions.FETCH_INVOICE_SUCCESS,
    payload,
  };
};

export const fetchInvoiceFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.FETCH_INVOICE_FAILURE,
    payload,
  };
};

export const checkSubscriptionAccountByIdAction = (
  payload: ICheckSubscriptionAccountByIdActionPayload
): ICheckSubscriptionAccountByIdAction => {
  return {
    type: subscriptionActions.CHECK_SUBSCRIPTION_ACCOUNT_BY_ID,
    payload,
  };
};

export const checkSubscriptionAccountByIdSuccessAction = (
  payload: ISubscriptionAccount
) => {
  return {
    type: subscriptionActions.CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_SUCCESS,
    payload,
  };
};

export const checkSubscriptionAccountByIdFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.CHECK_SUBSCRIPTION_ACCOUNT_BY_ID_FAILURE,
    payload,
  };
};

export const createSubscriptionAccountAction = (
  payload: ISubscriptionAccountWithCallback
): ICreateSubscriptionAccountByIdAction => {
  return {
    type: subscriptionActions.CREATE_SUBSCRIPTION_ACCOUNT,
    payload,
  };
};

export const createSubscriptionAccountSuccessAction = (
  payload: ISubscriptionAccountWithCallback
) => {
  return {
    type: subscriptionActions.CREATE_SUBSCRIPTION_ACCOUNT_SUCCESS,
    payload,
  };
};

export const createSubscriptionAccountFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.CREATE_SUBSCRIPTION_ACCOUNT_FAILURE,
    payload,
  };
};

export const updateSubscriptionAccountAction = (
  payload: ISubscriptionAccountWithCallback
): IUpdateSubscriptionAccountByIdAction => {
  return {
    type: subscriptionActions.UPDATE_SUBSCRIPTION_ACCOUNT,
    payload,
  };
};

export const updateSubscriptionAccountSuccessAction = (
  payload: ISubscriptionAccount
) => {
  return {
    type: subscriptionActions.UPDATE_SUBSCRIPTION_ACCOUNT_SUCCESS,
    payload,
  };
};

export const updateSubscriptionAccountFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.UPDATE_SUBSCRIPTION_ACCOUNT_FAILURE,
    payload,
  };
};

export const createSubscriptionAction = (payload: IcreateSubcription) => {
  return { type: subscriptionActions.CREATE_SUBSCRIPTION, payload };
};
export const createPaymentSessionAction = (payload: ICreateSession) => {
  return { type: subscriptionActions.CREATE_PAYMENT_SESSION, payload };
};
// export const updatePaymentMethodAction = (payload: IUpdatePaymentMethod) => {
//   return { type: subscriptionActions.UPDATE_PAYMENT_METHOD, payload };
// };

export const updateInvoiceList = (payload: InvoiceData[]) => {
  return { type: subscriptionActions.UPDATE_INVOICE_LIST, payload };
};

export const fetchInvoicePayments = (payload: IFetchInvoiceData) => {
  return { type: subscriptionActions.FETCH_INVOICE_PAYMENTS, payload };
};

export const fetchInvoicePaymentsSuccess = (payload) => {
  return { type: subscriptionActions.FETCH_INVOICE_PAYMENTS_SUCCESS, payload };
};

export const fetchInvoicePaymentsFailure = (payload: string) => {
  return { type: subscriptionActions.FETCH_INVOICE_PAYMENTS_FAILURE, payload };
};

export const fetchPaymentIntent = (payload: IFetchIntent) => {
  return { type: subscriptionActions.FETCH_PAYMENT_INTENT, payload };
};
export const updatePaymentStatusAction = (
  payload: IUpdatePaymentStatusPayload
) => {
  return { type: subscriptionActions.UPDATE_PAYMENT_STATUS, payload };
};

export const fetchUserLocationAction = (payload: Icallback) => {
  return { type: subscriptionActions.FETCH_USER_LOCATION, payload };
};

export const fetchUserLocationSuccess = (payload: IGeoLocationResponse) => {
  return { type: subscriptionActions.FETCH_USER_LOCATION_SUCCESS, payload };
};

export const fetchUserLocationFailure = (payload: string) => {
  return { type: subscriptionActions.FETCH_USER_LOCATION_FAILURE, payload };
};

export const fetchAccountDetailsAction = (
  accountId: string
): IFetchAccountDetailsAction => {
  return {
    type: subscriptionActions.FETCH_ACCOUNT_DETAILS,
    payload: accountId,
  };
};

export const fetchAccountDetailsSuccessAction = (
  payload: ISubscriptionAccountData
) => {
  return {
    type: subscriptionActions.FETCH_ACCOUNT_DETAILS_SUCCESS,
    payload,
  };
};

export const fetchAccountDetailsFailureAction = (payload: string) => {
  return {
    type: subscriptionActions.FETCH_ACCOUNT_DETAILS_FAILURE,
    payload,
  };
};
export const setActiveProductName = (payload: ProductName) => {
  return {
    type: subscriptionActions.SET_ACTIVE_PRODUCT_NAME,
    payload,
  };
};

export const setActiveFormMode = (payload: string) => {
  return {
    type: subscriptionActions.SET_ACTIVE_FORM_MODE,
    payload,
  };
};

export interface IFetchUserSubscriptionsAction {
  type: typeof subscriptionActions.FETCH_USER_SUBSCRIPTIONS;
  payload: {
    userId: string;
    productName: string;
  };
}

export interface IFetchUserSubscriptionStatusAction {
  type: typeof subscriptionActions.FETCH_USER_SUBSCRIPTIONS;
  payload: {
    userId: string;
    productName: string;
    status:string;
  };
}


export interface IFetchSubscriptionInvoicesAction {
  type: typeof subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES;
  payload: {
    subscriptionId: string;
    userId: string;
  };
}

export interface IFetchPaymentStatusAction {
  type: typeof subscriptionActions.FETCH_PAYMENT_STATUS;
  payload: {
    subscriptionId: string;
  };
}

export const fetchUserSubscriptionsAction = (payload: { userId: string; productName: string; }): IFetchUserSubscriptionsAction => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTIONS,
  payload,
});

export const fetchUserSubscriptionsSuccessAction = (payload: { subscriptions: IUserSubscription[] }) => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTIONS_SUCCESS,
  payload,
});

export const fetchUserSubscriptionsFailureAction = (error: string) => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTIONS_FAILURE,
  payload: error,
});

export const fetchUserSubscriptionStatusAction = (payload: { userId: string; productName: string; status:string }): IFetchUserSubscriptionStatusAction => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTION_STATUS,
  payload,
});

export const fetchUserSubscriptionStatusSuccessAction = (payload: { subscriptions: IUserSubscription[] }) => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTIONS_STATUS_SUCCESS,
  payload,
});

export const fetchUserSubscriptionStatusFailureAction = (error: string) => ({
  type: subscriptionActions.FETCH_USER_SUBSCRIPTIONS_STATUS_FAILURE,
  payload: error,
});

export const fetchSubscriptionInvoicesAction = (payload: { subscriptionId: string; userId: string; }) => ({
  type: subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES,
  payload,
});

export const fetchSubscriptionInvoicesSuccessAction = (payload: { subscriptions: any }) => ({
  type: subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES_SUCCESS,
  payload,
});

export const fetchSubscriptionInvoicesFailureAction = (error: string) => ({
  type: subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES_FAILURE,
  payload: error,
});

export const fetchPaymentStatusAction = (payload: { subscriptionId: string; }) => ({
  type: subscriptionActions.FETCH_PAYMENT_STATUS,
  payload,
});

export const fetchPaymentStatusSuccessAction = (payload: { subscriptions: any }) => ({
  type: subscriptionActions.FETCH_PAYMENT_STATUS_SUCCESS,
  payload,
});

export const fetchPaymentStatusFailureAction = (error: string) => ({
  type: subscriptionActions.FETCH_PAYMENT_STATUS_FAILURE,
  payload: error,
});

export interface IFetchUserSubscriptionsAction {
  type: typeof subscriptionActions.FETCH_USER_SUBSCRIPTIONS;
  payload: {
    userId: string;
    productName: string;
  };
}

export interface IFetchUserSubscriptionStatusAction {
  type: typeof subscriptionActions.FETCH_USER_SUBSCRIPTIONS;
  payload: {
    userId: string;
    productName: string;
    status:string;
  };
}

export interface IFetchSubscriptionInvoicesAction {
  type: typeof subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES;
  payload: {
    subscriptionId: string;
    userId: string;
  };
}

export interface IFetchPaymentStatusAction {
  type: typeof subscriptionActions.FETCH_PAYMENT_STATUS;
  payload: {
    subscriptionId: string;
  };
}